import type {FC} from 'react';
import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Box} from '@wellstone-solutions/web';
import {NAVIGATION_NAMES} from 'constants/Navigation';
import {PageHeader} from 'components/PageHeader';
import {useStores} from 'hooks/useStores';
import {ContactNoteForm} from '../ContactNoteForm';

export const NewNotePage: FC = () => {
  const {appUIStore} = useStores();
  const [searchParams] = useSearchParams();
  const patientId = searchParams.get('patient') ?? undefined;

  useEffect(() => {
    appUIStore.setBreadcrumbs([
      {name: NAVIGATION_NAMES.notes, url: '/documentation/notes'},
      {
        name: NAVIGATION_NAMES.newNote,
        url: '/documentation/notes/new',
        active: true,
      },
    ]);
  }, [appUIStore]);

  return (
    <Box sx={styles.container}>
      <PageHeader title={NAVIGATION_NAMES.newNote} />
      <ContactNoteForm
        // A new ?patient= link on this page starts a fresh note, not the old one's answers
        key={patientId ?? 'blank'}
        initialMemberId={patientId}
      />
    </Box>
  );
};

const styles = {
  container: {
    maxWidth: '800px',
  },
};
